import React from "react";
import { MatxSuspense } from "../partials";
import { MatxLayouts } from "./index";
import useSettings from "../../../hooks/useSettings";

function MatxLayout(props) {
  const { settings } = useSettings();
  const Layout = MatxLayouts[settings.activeLayout];
  return (
    <MatxSuspense>
      <Layout {...props} />
    </MatxSuspense>
  );
}
export default MatxLayout;
